import { useState } from "react";

import { Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { Message, MessageSections } from "../../../components/message/message";
import BarekamButton, { NewHomeButtons } from "../../../components/button";
import BarekamText from "../../../components/text";

import { BarekamTextWrapper, WholSaleDialog } from "./styled.components";

import balloons from "../../../../assets/icons/balloons.png";
import RequestForm from "./RequestForm";

const Wholesale = () => {
  const [show, setShow] = useState<boolean>(false);
  
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "292px",
        padding: "4rem 2rem",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}
      id="wholesale"
    >
      <Box
        component="img"
        src={balloons}
        alt="Decorative Background"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      <Box sx={{ position: "relative", zIndex: 1 }}>
        <BarekamTextWrapper variant={"m"} fontWeight={600} align={"left"}>
          <Message
            messageKey={"whole_sale_title"}
            sectionId={MessageSections.MAIN}
          />
        </BarekamTextWrapper>
        <BarekamButton
          type={NewHomeButtons.WHITE}
          size={"l"}
          onClick={() => setShow(true)}
          endIcon={<ArrowForwardIcon />}
        >
          <BarekamText variant={"m"} fontWeight={600} align={"center"}>
            <Message
              messageKey={"whole_sale_title_button_text"}
              sectionId={MessageSections.MAIN}
            />
          </BarekamText>
        </BarekamButton>
      </Box>
      {show && (
        <WholSaleDialog headerLabel={<Message messageKey={'request_for_wholesale'} sectionId={MessageSections.CALCULATE} />} onCancel={() => setShow(false)} open={show}>
          <RequestForm setShow={setShow} />
        </WholSaleDialog>
      )}
    </Box>
  );
};

export default Wholesale;
